/**
 * fmtTime — mirror of backend `utils/fmt_time.py` (CR-0015 / Δ-14).
 *
 * `Xh Ym Zs` / `Ym Zs` / `Zs`.
 */
export function fmtTime(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m}m ${sec}s`;
  if (m > 0) return `${m}m ${sec}s`;
  return `${sec}s`;
}

export function fmtClock(iso) {
  // Format an ISO datetime string as `H:MM AM/PM` (no leading zero on hour).
  const d = new Date(iso);
  let h = d.getHours();
  const mins = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${mins} ${ampm}`;
}

export function todayIso() {
  // Return today as `YYYY-MM-DD` in the viewer's local time (close enough
  // for IST users; backend will interpret in IST per C-26 regardless).
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function daysAgoIso(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function displayDate(iso) {
  // `YYYY-MM-DD` → `D/M/YYYY` (matches the screenshot's date format).
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${parseInt(d, 10)}/${parseInt(m, 10)}/${y}`;
}
